export const ROLE_LABELS = {
  EXECUTIVE: "Agent",
  AGENT: "Agent",
  SUPERVISOR: "Supervisor",
  UNDER_SECRETARY: "Approver",
  DEPARTMENT_USER: "Department User",
  MANAGER: "Manager",
  ADMIN: "Admin",
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role || "—";

export const USER_TYPE_OPTIONS = [
  { label: "Agent", value: "AGENT" },
  { label: "Supervisor", value: "SUPERVISOR" },
  { label: "Approver", value: "UNDER_SECRETARY" },
  { label: "Department User", value: "DEPARTMENT_USER" },
  { label: "Manager", value: "MANAGER" },
  { label: "Admin", value: "ADMIN" },
];
